import React, { useEffect, useState } from "react";
import { Modal as AntModal, Button, Form, Input, message, Switch } from "antd";
import styled from "styled-components";
import { CheckOutlined } from "@ant-design/icons";
import api from "../../../../../api/api";
import { localStorage } from "@utils";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e1e1e;
  }

  .ant-modal-close-icon svg {
    font-size: 24px;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-form-item {
    margin-bottom: 16px;

    :last-child {
      margin-bottom: 0 !important;
    }
  }

  .ant-btn-primary {
    margin-top: 24px;
    width: 100%;
    height: 56px;
  }
`;

const SwitchLabel = styled.div`
  margin-top: -40px;
  margin-left: 50px;
`;

const CreateUpdateCountryModal = ({
  open,
  isEdit,
  item,
  handleClose,
  successCallback,
}) => {
  const [loading, setLoading] = useState(false);
  const [is_active, setIsActive] = useState(true);
  const [form] = Form.useForm();

  const storeLang = localStorage.getStoreLang() || [];
  const langCount = storeLang?.length;

  useEffect(() => {
    if (open) {
      if (isEdit) {
        form.setFieldValue("is_active", item.is_active);
        form.setFieldValue("name_primary", item.name?.primary);
        form.setFieldValue("name_secondary", item.name?.secondary);
      } else {
        form.setFieldValue("is_active", true);
        form.setFieldValue("name_primary", "");
        form.setFieldValue("name_secondary", "");
      }
    }

    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (isEdit) {
      setIsActive(item.is_active);
    } else {
      setIsActive(true);
    }

    // eslint-disable-next-line
  }, [item, isEdit]);

  const onFinish = ({ name_primary, name_secondary, is_active }) => {
    if (!loading) {
      setLoading(true);
      let payload = {
        is_active,
        name: {
          primary: name_primary,
          secondary: langCount === 2 ? name_secondary : "",
        },
      };
      if (isEdit) {
        payload.id = item.id;
      }
      api[isEdit ? "editCountry" : "createCountry"](payload)
        .then(() => {
          setLoading(false);
          message.success(
            isEdit
              ? "Saved the update successfully!"
              : "Saved the country successfully!"
          );
          successCallback();
          handleClose();
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  const onFieldsChange = () => {
    setIsActive(form.getFieldValue("is_active"));
  };

  return (
    <Modal
      centered
      open={open}
      title={isEdit ? "Edit Country" : "Add Country"}
      footer={false}
      onCancel={onCancel}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFieldsChange={onFieldsChange}
      >
        <Form.Item
          name={"name_primary"}
          label={`Country Name (${storeLang[0]?.language})`}
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Input />
        </Form.Item>
        {langCount === 2 &&
        <Form.Item
          name={"name_secondary"}
          label={`Country Name (${storeLang[1]?.language})`}
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Input />
        </Form.Item>
          }
        <Form.Item name={"is_active"} valuePropName="checked">
          <Switch />
        </Form.Item>
        <SwitchLabel>{is_active ? "Active" : "Inactive"}</SwitchLabel>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            icon={<CheckOutlined />}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateUpdateCountryModal;
